<template>
  <div class="vz-cargo-view-item">
    <div class="vz-cargo-view-item-title">
      {{ cardTitle }}
    </div>
    <div class="vz-cargo-view-item-list">
      <div v-if="hasType">
        Тип:
        <span class="vz-cargo-view-item-value">{{ type }}</span>
      </div>
      <div v-if="dimension.length">
        Длина:
        <span class="vz-cargo-view-item-value">{{ dimension.length }} м</span>
      </div>
      <div v-if="dimension.width">
        Ширина:
        <span class="vz-cargo-view-item-value">{{ dimension.width }} м</span>
      </div>
      <div v-if="dimension.height">
        Высота:
        <span class="vz-cargo-view-item-value">{{ dimension.height }} м</span>
      </div>
      <div v-if="dimension.weight">
        Вес:
        <span class="vz-cargo-view-item-value">{{ dimension.weight }} кг</span>
      </div>
      <div v-if="dimension.count">
        Кол-во мест такого типа:
        <span class="vz-cargo-view-item-value">{{ dimension.count }} шт</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { palletTypes, parcelTypes } from '~/common/objects';
import { useOrderStore } from '~/stores/order';
import { OrderPallet, OrderParcel, OrderPlace } from '~/types/types';

const orderStore = useOrderStore()
const props = defineProps({
  dimension: {
    type: Object as PropType<Record<string, number | string>>,
    default: () => null
  },
  title: {
    default: ''
  }
})

const type = computed(() => {
  if (hasType.value) {
    if (orderStore.orderForm.cargo.mode === 'parcels') {
      return parcelTypes.find(item => item.value === props.dimension.type)?.title || ''
    }
    if (orderStore.orderForm.cargo.mode === 'pallets') {
      return palletTypes.find(item => item.value === props.dimension.type)?.title || ''
    }
  }
  return ''
})

const hasType = computed(() => {
  return props.dimension.type !== undefined
})

const cardTitle = computed(() => {
  return props.dimension.label || props.title
})
</script>
